import { LaydownLogRow } from './LaydownLogRow';

export class ApiLaydownLogRow {
  id?: number;
  storageFacility?: string;
  jobNumber?: string;
  contact?: string;
  space?: string;
  dateIn?: string | null;
  estDuration?: number;
  estDateOut?: string | null;
  dateOut?: string | null;
  loggedBy?: string;
  loggedAt?: string | null;

  // Clear flags for date fields
  clearDateIn?: boolean;
  clearDateOut?: boolean;
  clearEstDateOut?: boolean;

  public constructor(init?: Partial<LaydownLogRow>) {
    if (init) {
      // Copy all properties from init to this object
      Object.assign(this, init);

      // Check if dateIn is explicitly included but null/empty
      // This would indicate the user intentionally cleared the field
      if ('dateIn' in init) {
        if (init.dateIn && init.dateIn !== '' && init.dateIn !== undefined) {
          // Normal case - convert date to ISO string
          this.dateIn = new Date(init.dateIn).toISOString();
          this.clearDateIn = false;
        } else {
          // Field was explicitly set to null/empty
          this.dateIn = null;
          this.clearDateIn = true;
        }
      }

      // Same logic for dateOut
      if ('dateOut' in init) {
        if (init.dateOut && init.dateOut !== '' && init.dateOut !== undefined) {
          // Normal case - convert date to ISO string
          this.dateOut = new Date(init.dateOut).toISOString();
          this.clearDateOut = false;
        } else {
          // Field was explicitly set to null/empty
          this.dateOut = null;
          this.clearDateOut = true;
        }
      }

      // Same logic for estDateOut
      if ('estDateOut' in init) {
        if (
          init.estDateOut &&
          init.estDateOut !== '' &&
          init.estDateOut !== undefined
        ) {
          // Normal case - convert date to ISO string
          this.estDateOut = new Date(init.estDateOut).toISOString();
          this.clearEstDateOut = false;
        } else {
          // Field was explicitly set to null/empty
          this.estDateOut = null;
          this.clearEstDateOut = true;
        }
      }
    }
  }
}
